export default [{
    name: 'accredited',
    categoryTitle: 'An Accredited Investor',
    options: [{
        value: 'accredited_1',
        text: 'a company, other than an investment fund, that has net assets of at least $5,000,000, as shown on its most recently prepared financial statements'
    }, {
        value: 'accredited_2',
        text: 'a company that is entirely owned by an individual or individuals who are accredited investors'
    }, {
        value: 'accredited_3',
        text: 'a trust established by an accredited investor for the benefit of the accredited investor’s family members of which a majority of the trustees are accredited investors and all of the beneficiaries are the accredited investor’s spouse, a former spouse or a parent, grandparent, brother, sister, child or grandchild of that accredited investor, of that accredited investor’s spouse or of that accredited investor’s former spouse'
    }, {
        value: 'accredited_4',
        text: 'a company that otherwise qualifies as an accredited investor'
    }]
}, {
    name: 'other',
    categoryTitle: 'Not An Accredited Investor',
    options: [{
        value: 'other',
        text: 'my company does not meet the accredited investor qualifications as defined in section 2.3 of National Instrument 45-106 “Prospectus Exemptions” and I understand I may have some limits on my investment'
    }]
}, {
    name: 'permitted',
    categoryTitle: 'Permitted client or registered securities advisor – no advice',
    options: [{
        value: 'permitted_1',
        text: 'a company, other than an investment fund, that has net assets of at least $25 million as shown on its most recently prepared financial statements, and as such, waive my right to rely on advice on the suitability of my purchase of securities'
    }, {
        value: 'permitted_2',
        text: 'a company that is entirely owned by an individual or individuals who each beneficially own financial assets that have an aggregate realizable value that, before taxes but net of any related liabilities are in excess of $5 million, or otherwise qualify as a permitted client, and as such, waive my right to rely on advice on the suitability of my purchase of securities (Financial assets include cash, securities or a contract of insurance deposit or evidence of a deposit that is not a security for the purposes of securities legislation. The value of your residence or other real estate is not included in the calculation of financial assets)'
    }, {
        value: 'permitted_3',
        text: 'a company that otherwise qualifies as a permitted client and as such, waive my right to rely on advice on the suitability of my purchase of securities'
    }]
}]